import apiClient from 'src/Common/apiClient'

const fetchGroupDetails = async (token, groupId) => {
  try {
    const response = await apiClient.get('/InternshipGroup/Mentor/Groups/Light', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    // api-dev2: tolerate a paginated ({ items }) list; group own id may be `id` (fallback to groupId).
    const d = response.data
    const arr = Array.isArray(d) ? d : d?.items ?? []
    return arr.find(
      (group) => (group.id ?? group.groupId) === parseInt(groupId) && !group.groupAssigned,
    )
  } catch (error) {
    console.error('Error fetching group details:', error)
    throw error
  }
}

export { fetchGroupDetails }
